/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home__Hero__TitleInputs */

const en_home__hero__title = /** @type {(inputs: Home__Hero__TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unleash the Thrill of Winning`)
};

/**
* | output |
* | --- |
* | "Unleash the Thrill of Winning" |
*
* @param {Home__Hero__TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home__hero__title = /** @type {((inputs?: Home__Hero__TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home__Hero__TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home__hero__title(inputs)
});